import { useTheme } from '@mui/styles';
import {
    Deposit,
    Export,
    HandshakeIcon,
    Redeem,
    Send,
    Transact,
    Withdrawal
} from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { ActionButtonProps, PaymentsActionButtonProps } from './types';

export function CircleIconButton(props: ActionButtonProps) {
    const {
        changeActionScreen,
        Icon,
        iconColor,
        text,
        isDisabled
    } = props;

    const classes = muiStyles(props);
    const containerStyle = isDisabled ? classes.disabledContainer : classes.normalContainer;
    const textStyle = isDisabled ? classes.actionButtonTextDisabled : classes.actionButtonText;

    return (
        <button
            className={classes.actionButton}
            disabled={isDisabled}
            onClick={() => changeActionScreen(text)}
            type='button'
        >
            <div className={containerStyle}>
                <Icon
                    className={classes.actionButtonIcon}
                    iconColor={iconColor}
                />
            </div>
            <div className={textStyle}>{text}</div>
        </button>
    );
}

export function PaymentButton(props: PaymentsActionButtonProps) {
    const {
        text,
        type,
        changeActionScreen,
        isWalletFrozen
    } = props;
    const theme = useTheme<typeof muiTheme>();

    const ButtonIcon = React.useMemo(() => {
        switch (type) {
            case 'createPledge':
                return HandshakeIcon;
            case 'deposit':
                return Deposit;
            case 'redeem':
                return Redeem;
            case 'send':
                return Send;
            case 'import':
                return Export;
            case 'transact':
                return Transact;
            case 'withdraw':
                return Withdrawal;
            default:
                return Export;
        }
    }, [type]);

    return (
        <CircleIconButton
            changeActionScreen={changeActionScreen}
            Icon={ButtonIcon}
            iconColor={theme?.app?.applicationColors.enumColors.white || '#FFF'}
            isDisabled={isWalletFrozen}
            text={text ? text.toUpperCase() : type.toUpperCase()}
        />
    );
}